import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { routes } from './app.routes';
import { ProductTabsResolver } from './scip/pages/products-page';
import { ProductsPageComponent } from './scip/pages/products-page/products-page.component';
import { DashboardGuard, UnsavedTabsGuard } from './scip/core';
import { LogoutComponent } from './scip/core/authentication/logout';
import { ProductPreferencesResolver } from './scip/pages/products-page/products-preferences.resolver';

export const appRoutes: Routes = [
  {
    path: routes.dashboard,
    loadChildren: () => import('./scip/pages/dashboard-page/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [DashboardGuard]
  },
  {
    path: routes.products,
    component: ProductsPageComponent,
    canDeactivate: [UnsavedTabsGuard],
    resolve: [ProductTabsResolver, ProductPreferencesResolver],
    runGuardsAndResolvers: 'always'
  },
  {
    path: routes.logout,
    component: LogoutComponent
  },
  {
    path: routes.submissions,
    loadChildren: () => import('./scip/pages/submission/submission.module').then((m) => m.SubmissionModule)
  },
  {
    path: routes.scipPreferences,
    loadChildren: () => import('./scip/pages/scip-preferences/scip-preferences.module').then((m) => m.ScipPreferencesModule)
  },
  {
    path: routes.envOverview,
    loadChildren: () => import('./scip/pages/environment-overview/environment-overview.module').then((m) => m.EnvironmentOverviewModule)
  },
  {
    path: '',
    redirectTo: routes.dashboard,
    pathMatch: 'full'
  },
  { path: '**', redirectTo: routes.dashboard }
];

export const AppRouting: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes);
